import PageProtected from "../../components/Page/PageProtected";
import Grid from '@mui/material/Grid';
import SectionRecords from "./SectionRecords";
import { useTheme } from "@mui/material";
import SectionDashboard from "../../components/Section/SectionDashboard";

export default function RecordsWelcome() {
   
    const theme = useTheme();

return (
<>

<PageProtected

        headline="Health Incidents - "
        specify="History & Record Archive"
        main={<>

        {theme.palette.mode === "light" ? (
            <SectionDashboard colorContainer="transparent" colorSection_1="grey.C300" Section_1={ <SectionRecords />  }  />

        ):(

            <SectionDashboard colorContainer="transparent" colorSection_1="secondarydark.C100" Section_1={ <SectionRecords /> } />
    )}
    </>
    }
/>

</>
)
}